import { Card, Grid, useTheme } from "@mui/material"


export const CallToAction = ({ content }: { content: React.ReactNode }) => {
    const theme = useTheme();
    return (
        <Card
            sx={{
                borderRadius: 3,
                border: `1px solid ${theme.palette.divider}`,
                boxShadow: "0 4px 20px -2px rgba(0, 0, 0, 0.05), 0 2px 10px -2px rgba(0, 0, 0, 0.03)",
                bgcolor: "var(--fx-surface-base, #FFFFFF)",
                overflow: "hidden",
                mb: 4,
            }}
        >
            <Grid container>
                <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                        p: 4,
                        borderBottom: { xs: `1px solid ${theme.palette.divider}`, md: "none" },
                        borderRight: { xs: "none", md: `1px solid ${theme.palette.divider}` },
                    }}
                >
                    {content}
                </Grid>
            </Grid>
        </Card>
    )
}